jQuery(function ($) {
  $("#contact").validate({
    rules: {
      name: { required: true },
      phone: {
        required: true,
        number: true,
      },
      email: { required: true, email: true }
    },
    messages: {
      phone: {
        number: "Please enter numbers only",
      },
      email: {
        email: "Please enter a valid email address",
      },
    },
    errorClass: "error-contact",
    errorElement: "p",
    submitHandler: function (form) {
      console.log("entre al form");
      $("#submit_btn").prop("disabled", true);
      $("#success-form").hide();
      // Check if the reCAPTCHA has been completed
			if (window.grecaptcha && !grecaptcha.getResponse()) {
        $('#error_captcha').text('Please complete the CAPTCHA.');
        return;
      }
      $.ajax({
        url: cltvo_js_vars.ajax_url,
        type: form.method,
        data: $(form).serialize(),
        success: function (response) {
          $("#name, #phone, #email, #message").val("");
          $("#submit_btn").prop("disabled", false);
          $("#success-form").fadeIn(100);
        },
        error: function (error) {
          $("#error_form").text(error.responseJSON.message).show();
        },
      });
    },
  });

  // Define las funciones en el ámbito global
  window.recaptchaCompleted = function() {
    $('#submit_btn').prop('disabled', false);
    $('#error_captcha').text('');
  };

  window.recaptchaExpired = function() {
    $('#submit_btn').prop('disabled', true);
    $("#success-form").text('');
  };

  window.recaptchaError = function() {
    $('#submit_btn').prop('disabled', true);
    $("#success-form").text('');
    $('#error_captcha').text('Please complete the CAPTCHA.');
  };
});